/**
 * @owner @Appboy/core-objects
 */
import { customObjectsTypeNameExternalId } from "../customObjectsTypeNameExternalId/constants";
import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsTypeName = "/custom_objects/:type_name" as const;

/** Invalidate list and item GET caches after create/update mutations on this type. */
export const customObjectsTypeNameCacheKeys: AllRouteEndpoints[] = [
  customObjectsTypeName,
  customObjectsTypeNameExternalId,
];
